export default {
  flipHeader: 'Flip Call to...',
  flip: 'Flip',
  complete: 'Complete Flip',
} as const;
